import Table from "../../extra/Table";
import Button from "../../extra/Button";
import Iconb from "../../extra/Iconb";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import { connect, useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import {
  getShippingMethod,
  deleteShippingMethod,
} from "../../store/shippingMethod/shippingMethod.action";
import { getDefaultCurrency } from "../../store/currency/currency.action";
import dayjs from "dayjs";
import ShippingMethodDialog from "./ShippingMethodDialog";
import { warning } from "../../../util/Alert";

const ShippingMethod = (props) => {
  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const dispatch = useDispatch();

  const { shippingMethod } = useSelector((state) => state.shippingMethod);
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const { defaultCurrency } = useSelector((state) => state.currency);

  useEffect(() => {
    dispatch(getShippingMethod());
    dispatch(getDefaultCurrency());
  }, [dispatch]);

  useEffect(() => {
    setData(shippingMethod);
  }, [shippingMethod]);

  const handleDelete = (id) => {
    const data = warning();
    data
      .then((isDeleted) => {
        if (isDeleted) {
          props.deleteShippingMethod(id);
        }
      })
      .catch((err) => console.log(err));
  };

  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) => (
        <span className="text-white fw-normal">
          {parseInt(index) + 1}
        </span>
      ),
    },
    {
      Header: "Name",
      body: "name",
      Cell: ({ row }) => (
        <span className="text-white fw-normal">{row.name}</span>
      ),
    },
    {
      Header: "Type",
      body: "type",
      Cell: ({ row }) => (
        <span
          className="fw-normal"
          style={{
            color: row.type === "overseas" ? "#4FC3F7" : "#81C784",
            textTransform: "capitalize",
          }}
        >
          {row.type}
        </span>
      ),
    },
    {
      Header: `Cost (${defaultCurrency?.symbol || ''})`,
      body: "cost",
      Cell: ({ row }) => (
        <span className="text-white fw-normal">{defaultCurrency?.symbol || ''}{row.cost}</span>
      ),
    },
    {
      Header: "Duration",
      body: "duration",
      Cell: ({ row }) => (
        <span className="text-white fw-normal">{row.duration}</span>
      ),
    },
    {
      Header: "Status",
      body: "isActive",
      Cell: ({ row }) => (
        <span
          className="fw-bold"
          style={{
            color: row.isActive ? "#81C784" : "#FF4C51",
          }}
        >
          {row.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },
    {
      Header: "Created",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-white fw-normal">
          {dayjs(row.createdAt).format("DD MMM YYYY")}
        </span>
      ),
    },
    {
      Header: "Edit",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter infobtn userBtn fs-5`}
          btnIcon={<CreateOutlinedIcon sx={{ color: "#737272" }} />}
          style={{
            borderRadius: "50px",
            margin: "auto",
            height: "45px",
            width: "45px",
            color: "#160d98",
          }}
          isImage={true}
          onClick={() =>
            dispatch({
              type: OPEN_DIALOGUE,
              payload: { data: row, type: "shippingMethod" },
            })
          }
        />
      ),
    },
    {
      Header: "Delete",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter killbtn userBtn fs-5`}
          btnIcon={<DeleteIcon sx={{ color: "#FF4C51" }} />}
          style={{
            borderRadius: "50px",
            margin: "auto",
            height: "45px",
            width: "45px",
            color: "#160d98",
            padding: "0px",
          }}
          isImage={true}
          isDeleted={true}
          onClick={() => handleDelete(row._id)}
        />
      ),
    },
  ];

  return (
    <>
      <div className="mainSellerTable">
        <div className="sellerTable">
          <div className="col-12 headname">Shipping Methods</div>
          <div className="sellerMain">
            <div className="tableMain mt-2">
              <div className="row">
                <div className="col-12" style={{ margin: "12px" }}>
                  <Button
                    newClass={`whiteFont`}
                    btnColor={`btnBlackPrime`}
                    btnIcon={`fa-solid fa-plus`}
                    btnName={`Add`}
                    onClick={() => {
                      dispatch({
                        type: OPEN_DIALOGUE,
                        payload: { type: "shippingMethod" },
                      });
                    }}
                    style={{
                      borderRadius: "5px",
                      padding: "8px 32px",
                      background: "#F0C420",
                    }}
                  />
                  {dialogue && dialogueType === "shippingMethod" && (
                    <ShippingMethodDialog />
                  )}
                </div>
                <div className="col-2 text-end"></div>
              </div>
              <Table
                data={data}
                mapData={mapData}
                PerPage={rowsPerPage}
                Page={page}
                type={"client"}
              />
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { getShippingMethod, deleteShippingMethod })(
  ShippingMethod
);
